@import 'ss-ui-client/src/constants/spacing.module.less';

.canvas {
  width: 100%;
  align-items: center;
  flex: 1;
}
